import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { selectDictLabel } from '@/utils/formatter'

Vue.prototype.selectDictLabel = selectDictLabel
// 1 钉钉  2 浙政钉
Vue.prototype.dtalktype = 1

Vue.use(Vant)
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

